import { config } from '@config'
import { storage } from '@services/storageService'
import { HttpService } from '@services/HttpService'
export class DeleteBuyingSessionGroupAPIService {
  httpService = new HttpService()
  deleteBuyingSessionGroup = async bsgId => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}buyingSessionGroup/${bsgId}`
      const accessToken: string = storage.getItem('access_token')

      const response = await this.httpService.delete(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response
    } catch (e) {
      console.log(e)
    }
  }

  deleteBuyingSessionGroupAndClients = async (bsgId, clientIds) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}buyingSessionGroup/${bsgId}/clients/${clientIds}`
      const accessToken: string = storage.getItem('access_token')

      const response = await this.httpService.delete(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response
    } catch (e) {
      console.log(e)
    }
  }
}
